import { defineWave } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   PRÉDATION — vitrine des cinq menaces neuves.

   Une vague de démonstration pour les archétypes de cette passe : Faucon
   (kamikaze traqueur), Mitrailleur (rafale de lasers), Rempart (bouclier frontal
   large), Kyste (bouclier « bulle » à crever), Pondeuse (ponte d'œufs qui
   éclosent), et Prisme (faisceau pleine hauteur télégraphié). Chacun est
   introduit SEUL puis laissé respirer, dans l'ordre de sa difficulté de lecture —
   la même discipline que le monde 1 impose à l'Éclat avant le Faucheur : une
   leçon donnée au milieu du bruit n'est pas une leçon.

   Les ennemis résistants (Rempart 380, Pondeuse 220, Prisme 300 PV) sont placés
   dans les couloirs centraux : les couloirs de bord (0 et 6) refusent tout
   ennemi de plus de 200 PV, et le registre le vérifie au chargement.

   ⚠️ Elle n'est volontairement câblée dans AUCUN niveau de la campagne. Le
   câblage d'un monde relève de l'équilibrage (courbe de puissance, respirations,
   silence d'avant-boss) et appartient au propriétaire du contenu de campagne, pas
   à l'ajout de ces archétypes. La vague existe pour prouver que la chaîne
   registre → levelSystem → pool → conduite/ponte/bouclier tient de bout en bout ;
   on la dépose dans un niveau le jour où l'on compose le monde qui les emploie.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineWave({
  id: 'predation',
  duration: 34,
  spawns: [
    // 1. Faucon — le corps qui traque puis pique puis se retire. La leçon la
    //    plus directe : on lit une trajectoire. Deux, décalés, pour montrer la
    //    traque sur un joueur qui bouge.
    { at: 0.5, enemy: 'faucon', lane: 3, count: 2, spacing: 1.6 },

    // 2. Mitrailleur — la rafale : tenir un déplacement pendant toute la salve.
    //    Deux postes, de part et d'autre, pour que le déplacement tenu doive
    //    composer avec deux directions de tir.
    { at: 6.0, enemy: 'mitrailleur', lane: 2, count: 1, spacing: 0 },
    { at: 6.6, enemy: 'mitrailleur', lane: 4, count: 1, spacing: 0 },

    // 3. Rempart — le bouclier frontal large : contourner, se hisser sur le
    //    flanc. Seul et central, le temps de chercher l'angle.
    { at: 11.0, enemy: 'rempart', lane: 3, count: 1, spacing: 0 },

    // 4. Kyste — le bouclier « bulle » : crever avant le corps, en esquivant son
    //    anneau. L'ordre imposé, après l'angle imposé.
    { at: 16.0, enemy: 'kyste', lane: 3, count: 1, spacing: 0 },

    // 5. Pondeuse — la priorité de cible : couper la source ou désamorcer les
    //    œufs avant qu'ils n'éclosent. Seule, pour voir l'essaim monter si on
    //    l'ignore.
    { at: 21.0, enemy: 'pondeuse', lane: 3, count: 1, spacing: 0 },

    // 6. Prisme — la colonne pleine hauteur télégraphiée : évacuer une zone à
    //    l'avance. En dernier, car c'est la lecture spatiale la plus exigeante.
    { at: 27.0, enemy: 'prisme', lane: 3, count: 1, spacing: 0 },
  ],
});
